// @flow
import { Event } from "@mui/icons-material";
import InputAdornment from "@mui/material/InputAdornment";
import { DateRangePicker, SingleInputDateRangeField } from "@mui/x-date-pickers-pro";

type Props = {
	value: Array<Date>,
	onClear: Function,
	onChange: Function,
	dateFormat: string,
};

const DateRange = (props: Props) => {
	const {value, onChange, onClear, dateFormat} = props
	return (
		<DateRangePicker
			slotProps={{
				textField: {
					size: 'small',
					variant: 'standard',
					InputProps: {
						endAdornment: (
							<InputAdornment position="end" sx={{cursor: 'pointer'}}>
								<Event/>
							</InputAdornment>
						),
					},
				},
				field: {
					clearable: true,
					onClear: onClear,
				}
			}}
			slots={{
				field: SingleInputDateRangeField
			}}
			format={dateFormat}
			value={value}
			onChange={onChange}
		/>
	);
};

export default DateRange